// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"220":"ffbc03ab","513":"2f8ba035"}[chunkId] + ".css";
};